// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Typography, Flex } from '@teamnine/pcj-ui-v2'
import { ReactNode } from 'react'
import { useTheme } from 'styled-components'

type DetailItemProps = {
  label: string
  value?: ReactNode
  fallback?: ReactNode
}

export default function DetailItem({
  label,
  value,
  fallback = '-',
}: DetailItemProps) {
  const { colors } = useTheme()

  const displayValue =
    value === undefined || value === null || value === '' ? fallback : value

  return (
    <Flex direction="column" gap={8}>
      <Typography variant="body-m-semi-bold" color={colors.nggray950}>
        {label}
      </Typography>
      <Typography variant="body-m-regular">{displayValue}</Typography>
    </Flex>
  )
}
